// Module
var code = "<nav class=\"base-menu\">\n  <list>\n    <list-item v-for=\"item in items\" :key=\"item.routeName\">\n      <base-link :route-name=\"item.routeName\" :icon-name=\"item.iconName\">\n        {{ item.label }}\n      </base-link>\n    </list-item>\n    <slot></slot>\n  </list>\n</nav>\n";
// Exports
export default code;